<template>
  <v-app id="inspire">
<!--    <AgentSideBar :drawer="drawer"/>-->
    <AgentTopBar @drawerEvent="drawer = !drawer"/>
    <v-main style="background: #f5f5f540">
      <v-container class="py-8 px-6" fluid>
        <router-view></router-view>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import AgentSideBar from "./../components/AgentSidebar";
import AgentTopBar from "./../components/AgentTopbar";

export default {
  components: {AgentTopBar, AgentSideBar},
  data: () => ({
    cards: ["Today", "Yesterday"],
    drawer: null,
  }),
  methods: {},
  name: "agentLayout"
}
</script>

<style scoped>

</style>